import React from 'react';
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import $ from 'jquery';
import DataTable from "react-data-table-component";
import { Modal } from 'bootstrap';


function SaleReturn() {
    const [formData, setFormData] = useState({
        l1: [],
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        start_date: '',
        end_date: '',
        isAlert: false,
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [ldata, setLdata] = useState(null);
    const [selectedReturn, setSelectedReturn] = useState(null);
    const [returnItems, setReturnItems] = useState([]);
    const [image, setImage] = useState('');
    const [dataTable, setDataTable] = useState(null);

    // ✅ Fetch Config Data for Header Image
    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );
            if (res.data.status) {
                setImage(res.data.header_logo);
            }
        } catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    // ✅ Helper functions for PDF
    const imageUrlToBase64 = async (url) => {
        if (!url) return null;
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            if (!blob.type.startsWith('image/')) return null;
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image:", error);
            return null;
        }
    };

    const formatAge = (year, month, day) => {
        const parts = [];
        if (year) parts.push(`${year}Y`);
        if (month) parts.push(`${month}M`);
        if (day) parts.push(`${day}D`);
        return parts.length > 0 ? parts.join(" ") : "-";
    };

    const formatBillNo = (billId) => {
        return billId ? String(billId).padStart(3, "0") : "000";
    };

    const formatBillDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const numberToWords = (num) => {
        if (num === 0) return "Zero Rupees Only";
        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        
        const convertLessThanThousand = (n) => {
            if (n === 0) return "";
            if (n < 10) return ones[n];
            if (n < 20) return teens[n - 10];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
            return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "");
        };
        
        const crore = Math.floor(num / 10000000);
        const lakh = Math.floor((num % 10000000) / 100000);
        const thousand = Math.floor((num % 100000) / 1000);
        const remainder = num % 1000;
        
        let result = "";
        if (crore > 0) result += convertLessThanThousand(crore) + " Crore ";
        if (lakh > 0) result += convertLessThanThousand(lakh) + " Lakh ";
        if (thousand > 0) result += convertLessThanThousand(thousand) + " Thousand ";
        if (remainder > 0) result += convertLessThanThousand(remainder);
        
        return result.trim() + " Rupees Only";
    };

    // ✅ Generate Return Bill PDF
    const generateReturnBillPdf = async (returnData) => {
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;

        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;

        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
        }

        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Return Bill", pageWidth / 2, y, { align: "center" });
        y += 10;
        doc.rect(margin, y, pageWidth - 2 * margin, 95);

        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Return Details:", leftX, lineY);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);

        doc.text(
            `Patient Name : ${returnData.med_bill_return_patient_name || 'Walk-in Customer'}`,
            leftX,
            (lineY += 15)
        );

        const ageText = formatAge(
            returnData.med_bill_return_age_year,
            returnData.med_bill_return_age_month,
            returnData.med_bill_return_age_day
        );

        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${returnData.med_bill_return_phone || ''}`, leftX, (lineY += 15));
        doc.text(
            `Doctor : ${returnData.med_bill_return_doctor || '-'}`,
            leftX,
            (lineY += 15)
        );
        doc.setFont("helvetica", "bold");
        doc.text(`Return Reason : ${returnData.med_bill_return_reason || '-'}`, leftX, (lineY += 15));
        doc.setFont("helvetica", "normal");
        lineY = y + 15;

        doc.text(`UHID : ${returnData.med_bill_return_original_bill_number || ''}`, rightX, lineY);
        doc.text(`Return Bill No : ${formatBillNo(returnData.med_bill_return_bill_number)}`, rightX, (lineY += 15));
        doc.text(`Original Bill No : ${formatBillNo(returnData.med_bill_return_original_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Return Date : ${formatBillDate(returnData.med_bill_return_date)}`, rightX, (lineY += 15));
        doc.setFont("helvetica", "bold");
        doc.text(`Bill Type : RETURN`, rightX, (lineY += 15));
        doc.setFont("helvetica", "normal");

        y += 115;

        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"
        ]];
        const items = returnData._items || returnItems || [];
        const tableBody = (returnItems || []).map((med, index) => {
            const qty = parseInt(med.med_bill_return_item_qty || 0);
            const mrp = parseFloat(med.med_bill_return_item_mrp || 0);
            const discount = parseFloat(med.med_bill_return_item_discount || 0);
            const total = (mrp - discount) * qty;

            return [
                index + 1,
                med.med_bill_return_item_medicine || '',
                (med.med_bill_return_item_is_loose == 1 ? "Loose" : "Package"),
                qty,
                med.med_bill_return_item_batch || '',
                med.med_bill_return_item_exp || '',
                med.med_bill_return_item_hsn || '',
                discount.toFixed(2),
                mrp.toFixed(2),
                total.toFixed(2),
            ];
        });

        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 4 },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
        });

        y = doc.lastAutoTable.finalY + 15;

        const totalTax = (returnItems || []).reduce(
            (sum, i) => sum + parseFloat(i.med_bill_return_item_tax_amt || 0),
            0
        );

        const subtotal = parseFloat(returnData.med_bill_return_total || 0);
        const grandTotal = parseFloat(returnData.med_bill_return_final_amt || 0);

        doc.setFontSize(10);
        doc.text(`Subtotal`, pageWidth - margin - 200, y);
        doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

       

        doc.setFont("helvetica", "bold");
        doc.text(`Total Return Amount`, pageWidth - margin - 200, (y += 20));
        doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

        y += 30;
        doc.setFont("helvetica", "normal");
        doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
        
        y += 25;
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.text("Note: This is a return bill. Amount will be refunded as per store policy.", margin, y);
        
        y += 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

        window.open(doc.output("bloburl"), "_blank");
    };

    // ✅ Fetch Return Details
    const fetchReturnDetails = async (returnId) => {
        try {
            const fd = new FormData();
            fd.append('return_id', returnId);
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getReturnDetailsUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (!response.data.status) {
                throw new Error("Failed to load return details");
            }
    
            const bill = response.data.return_bill;
            const items = response.data.return_items || [];
    
            // update state (for modal)
            setSelectedReturn(bill);
            setReturnItems(items);
    
            return { bill, items }; // ✅ RETURN DATA
    
        } catch (error) {
            console.error("Error fetching return details:", error);
            toast.error("Error loading return details");
            return null;
        }
    };
    

    // ✅ Initialize Data with Date Filter
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (storedData) {
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            
            if (formData.start_date) {
                fd.append('start_date', formData.start_date);
            }
            if (formData.end_date) {
                fd.append('end_date', formData.end_date);
            }

            try {
                const response = await axios.post(
                    AppConst.BASE_URL + AppConst.getReturnListUrl, 
                    fd, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));

                        // ✅ Destroy existing DataTable if exists
                     

                        // ✅ Initialize DataTable after state update
                        
                    }
                }
            } catch (error) {
                console.error("Error fetching returns:", error);
                toast.error("Error loading returns");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // ✅ Handle Date Change - Auto fetch
     

    // ✅ Clear Dates
    const clearDates = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            start_date: today,
            end_date: today
        }));
    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            // Set today's date as default
            const today = new Date().toISOString().split('T')[0];
            setFormData(prev => ({
                ...prev,
                start_date: today,
                end_date: today
            }));
            
            fetchConfigData();
        }

        return () => {
            console.log('Component unmounted');
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, []);

    // ✅ Initial data load after dates are set
    useEffect(() => {
        if (formData.start_date && formData.end_date) {
            initData();
        }
    }, [formData.start_date, formData.end_date]);
    const columns = [
        {
            name: "Sl. No.",
            selector: (row, index) => index + 1,
            width: "80px"
        },
        {
            name: "Action",
            cell: row => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-sm btn-info"
                        onClick={async () => {
                            const res = await fetchReturnDetails(row.med_bill_return_id);
                            if (res) {
                                const modal = new Modal(
                                    document.getElementById('returnDetailsModal')
                                );
                                modal.show();
                                
                            }
                        }}
                        
                        title="View Details"
                    >
                        <i className="ri-eye-line"></i>
                    </button>
    
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={async () => {
                            const res = await fetchReturnDetails(row.med_bill_return_id);
                            if (res) {
                                generateReturnBillPdf({
                                    ...res.bill,
                                    _items: res.items // pass items explicitly
                                });
                            }
                        }}
                        
                        title="Print"
                    >
                        <i className="ri-printer-line"></i>
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            button: true,
            width: "140px"
        },
        {
            name: "Patient Name",
            selector: row => row.med_bill_return_patient_name || "-",
            sortable: true
        },
        {
            name: "Phone No",
            selector: row => row.med_bill_return_phone || "-",
            sortable: true
        },
        {
            name: "Doctor",
            selector: row => row.med_bill_return_doctor || "-",
            sortable: true
        },
        {
            name: "Reason",
            selector: row => row.med_bill_return_reason || "-",
            grow: 2
        },
        {
            name: "Return No",
            selector: row => row.med_bill_return_bill_number,
            sortable: true
        },
        {
            name: "Return Date",
            selector: row => formatBillDate(row.med_bill_return_date),
            sortable: true
        }
    ];
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#405189',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 'bold',
                borderRadius: '5px 5px 0 0'
            }
        },
        headCells: {
            style: {
                color: '#fff',
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        rows: {
            style: {
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer'
                }
            }
        }
    };
    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Sales Return</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-1 flex-wrap">
                                            <button
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    sessionStorage.removeItem("opd_dt");
                                                    window.location.href = "/sales_Return";
                                                }}
                                                className="btn btn-success add-btn"
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Add Return
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* ✅ Date Filter Section */}
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-xxl-3 col-sm-6">
                                        <label className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="start_date"
                                            value={formData.start_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-xxl-3 col-sm-6">
                                        <label className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="end_date"
                                            value={formData.end_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-sm-6 d-flex align-items-end">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={clearDates}
                                        >
                                            <i className="ri-refresh-line me-1"></i> Clear
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <div className="card-body pt-0">
                                <div className="table-responsive table-card mb-1">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    customStyles={customStyles}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    //expandableRows
                                   // expandableRowsComponent={ExpandedComponent}
                                    highlightOnHover
                                    pointerOnHover
                                    responsive
                                    striped
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-line fs-1 text-muted"></i>
                                            <p className="mt-3">No return found</p>
                                        </div>
                                    }
                                />
   

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ Return Details Modal */}
            <div className="modal fade" id="returnDetailsModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Return Bill Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedReturn && (
                                <div>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <h6>Patient Information</h6>
                                            <p><strong>Name:</strong> {selectedReturn.med_bill_return_patient_name}</p>
                                            <p><strong>Phone:</strong> {selectedReturn.med_bill_return_phone}</p>
                                            <p><strong>Age:</strong> {formatAge(selectedReturn.med_bill_return_age_year, selectedReturn.med_bill_return_age_month, selectedReturn.med_bill_return_age_day)}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6>Return Information</h6>
                                            <p><strong>Return No:</strong> {formatBillNo(selectedReturn.med_bill_return_bill_number)}</p>
                                            <p><strong>Original Bill:</strong> {formatBillNo(selectedReturn.med_bill_return_original_bill_id)}</p>
                                            <p><strong>Return Date:</strong> {formatBillDate(selectedReturn.med_bill_return_date)}</p>
                                            <p><strong>Doctor:</strong> {selectedReturn.med_bill_return_doctor}</p>
                                            <p><strong>Reason:</strong> {selectedReturn.med_bill_return_reason}</p>
                                        </div>
                                    </div>

                                    <h6>Returned Medicines</h6>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Medicine</th>
                                                    <th>Batch</th>
                                                    <th>Qty</th>
                                                    <th>MRP</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {returnItems.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{idx + 1}</td>
                                                        <td>{item.med_bill_return_item_medicine}</td>
                                                        <td>{item.med_bill_return_item_batch}</td>
                                                        <td>{item.med_bill_return_item_qty}</td>
                                                        <td>₹{item.med_bill_return_item_mrp}</td>
                                                        <td>₹{((parseFloat(item.med_bill_return_item_mrp) - parseFloat(item.med_bill_return_item_discount || 0)) * parseInt(item.med_bill_return_item_qty)).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 offset-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <p className="d-flex justify-content-between">
                                                        <span>Subtotal:</span>
                                                        <span>₹{selectedReturn.med_bill_return_total}</span>
                                                    </p>
                                                    <hr />
                                                    <h6 className="d-flex justify-content-between">
                                                        <span>Total Return Amount:</span>
                                                        <span>₹{selectedReturn.med_bill_return_final_amt}</span>
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => generateReturnBillPdf(selectedReturn)}
                            >
                                <i className="ri-printer-line me-1"></i> Print
                            </button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SaleReturn;